import { Typography } from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton'
import React from 'react'

import useStyles from './styles/PoliciesTable.styles'

const UserRowMobileSkeleton: React.FC = () => {
  const classes = useStyles()

  return (
    <>
      <div className={classes.tableRowMobile}>
        <div className={classes.nameCell}>
          <div>
            <Typography variant="body1">
              <Skeleton animation="wave" className={classes.skeleton} />
            </Typography>
          </div>
        </div>
      </div>
    </>
  )
}

export default UserRowMobileSkeleton
